import { Injectable, InjectionToken, Injector } from "@angular/core";
import { InternationalisationService } from "../forked/angular-internationalisation";
import { CoreLanguages } from "../languages/languages";
import { CustomLanguages } from "../../custom/languages/languages";
import { Subscription } from "rxjs";
import { environment } from "../../../environments/environment";
import { YourAPPProductType } from "../shared/contentTypes";
import { ISOTLanguageService } from "../../sot/services/ILanguageService";
import { SOT_LANGUAGE_SERVICE_INJECTION_TOKEN } from "../../sot/injectionToken";

/** Sprache und Lokalisierung */

/** Verwaltet die Sprachen */
@Injectable({
  providedIn: "root" // sollte nur mit der Anwendung zerstört werden
})
export class CoreLanguageService {

  private _sotLanguageService: ISOTLanguageService;
  private _sotLanguageChangedSunbscription: Subscription;

  /** Konstruktor
   * @param internationalisationService Basiert auf diesem Service, wird per Injection mitgegeben
   */
  constructor(private _internationalisationService: InternationalisationService,
    injector: Injector) {
    const me = this;
    // initialisiert sich gleich im Construktor
    if (environment.producttype == YourAPPProductType.sot) {
      // inject SOTLanguageService, so that ist not automaticly inject in not sot Projects
      me._sotLanguageService = injector.get(SOT_LANGUAGE_SERVICE_INJECTION_TOKEN);
      me.setSOTLanguages();
      me._sotLanguageChangedSunbscription = me._sotLanguageService.ObserveChanges.subscribe(() => {
        me.setSOTLanguages();
      });
    } else {
      me.setLanguages();
    }
  }

  public ngOnDestroy(): void {
    const me = this;
    if (me._sotLanguageChangedSunbscription) {
      me._sotLanguageChangedSunbscription.unsubscribe();
    }
  }

  /** Nutzt das SOTLanguageService  */
  private setSOTLanguages() {
    const me = this;
    me._sotLanguageService.getLanguages().then((languages) => {
      me._internationalisationService.setLocales(languages);
    }).catch((error) => {
      console.error({ "msg": "CoreLanguageService.setSOTLanguages error on _sotLanguageService.getLanguages", "error": error });
      me._internationalisationService.setLocales({}); // empty languages
    });
  }

  /** Erstellt die aktuelle Sprachkonfiguration aus Core- und Customsprachen */
  private setLanguages() {
    const me = this;
    // Clone CoreLanguages
    const languages = { ...CoreLanguages };

    // Extend by CustomLanguages
    for (const custom_language in CustomLanguages) {
      if (CustomLanguages.hasOwnProperty(custom_language)) {
        if (languages.hasOwnProperty(custom_language)) {
          // erweiterung der LanguageKey's, bei gleichheit, wird core durch custom überschrieben
          languages[custom_language] = { ...languages[custom_language], ...CustomLanguages[custom_language] };
        } else {
          // custom_language ist nicht in core, dann anlegen
          languages[custom_language] = { ...CustomLanguages[custom_language] };
        }
      }
    }

    me._internationalisationService.setLocales(languages);
  }

  /** Gibt den Wert zu dem Schlüssel der aktuellen Sprachkonfiguration zurück
   * @param key LanguageKey wie etwa 'phModul_KeyName'
   */
  public value(key: string): string {
    return this._internationalisationService.getCurrentLocaleValue(key);
  }

  /** Gibt den Wert zu dem Schlüssel der aktuellen Sprachkonfiguration zurück, in einem HTML sicheren zustand
   * @param key LanguageKey wie etwa 'phModul_KeyName'
   */
  public valueSafe(key: string): string {
    return this._internationalisationService.getCurrentLocaleValueSafe(key);
  }

  /** Setzt die aktuell verwendete Sprache
   * @param language Sprachschlüssel (z.B. "de" oder "en")
   */
  public setCurrentLanguage(language: string) {
    this._internationalisationService.setCurrentLocale(language);
  }

  /** Gibt den Sprachschlüssel zu der aktuell verwendeten Sprache zurück */
  public getCurrentLanguage(): string {
    return this._internationalisationService.getCurrentLocale();
  }
}
